import React, { memo, useCallback, useEffect, useState } from 'react';
import { Search } from '@material-ui/icons';
import { debounce } from 'lodash';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import ThemedTextField from 'common/ThemedTextField';
import NestedSelect from 'common/NestedSelect';

import './SpecificationsFilters.scss';

const searchIcon = <Search />;
const sortings = {
  filters: [
    {
      text: i18n.t('modified_date'),
      value: 'modifiedDate',
      selected: true,
    },
    {
      text: i18n.t('created_date'),
      value: 'createdDate',
      selected: false,
    },
    {
      text: i18n.t('name'),
      value: 'name',
      selected: false,
    },
  ],
  orders: [
    {
      text: i18n.t('ascending'),
      value: 'asc',
      selected: false,
    },
    {
      text: i18n.t('descending'),
      value: 'desc',
      selected: true,
    },
  ],
};
const SpecificationsFilters = ({ folderId, onSearch, onChangeOptions }) => {
  const { t } = useTranslation();
  const [sortingOptions, setSortingOptions] = useState(sortings);
  const [sorting, setSorting] = useState(t('lack'));
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    setSortingOptions(sortings);
    setSorting(i18n.t('modified_date'));
    setSearchInput('');
  }, [folderId, t]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearch = useCallback(
    debounce((e) => onSearch(e), 500),
    []
  );

  const handleSearch = useCallback(
    (e) => {
      setSearchInput(e.target.value);
      debounceSearch(e.target.value);
    },
    [debounceSearch]
  );

  const handleClearSearch = useCallback(() => {
    setSearchInput('');
    debounceSearch('');
  }, [debounceSearch]);

  const handleChangeSorting = useCallback(
    ({ target: { text, optionKey } }) => {
      if (optionKey === 'filters') {
        setSorting(text);
      }
      const options = {
        ...sortingOptions,
        [optionKey]: sortingOptions[optionKey].map((opt) => ({
          ...opt,
          selected: opt.text === text,
        })),
      };
      const sortingVal = options?.filters?.find((srtOpt) => srtOpt.selected)?.value || '';
      const orderVal = options?.orders?.find((ordOpt) => ordOpt.selected)?.value;

      onChangeOptions(sortingVal, orderVal, text);

      setSortingOptions(options);
    },
    [onChangeOptions, sortingOptions]
  );

  return (
    <div className="SpecificationsFilters">
      <ThemedTextField
        icon={searchIcon}
        label={t('type_search_text')}
        name="productFullName"
        value={searchInput}
        onChange={handleSearch}
        onClickClear={handleClearSearch}
        className="filters__search"
      />

      <NestedSelect
        variant="Dropdown"
        value={sorting}
        name="sorting"
        onChange={handleChangeSorting}
        options={sortingOptions}
        label={t('sorting')}
        className="filters__sortings"
      />
    </div>
  );
};

export default memo(SpecificationsFilters);
